import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import { ParameterDTO } from '../../customs/_models/ParameterDTO';
import { SubstanceDTO } from '../../customs/_models/SubstanceDTO';
import { ProductPesticideMRL } from '../../customs/_models/ProductPesticideMRL';
import { catchError} from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ParametreService {

    private readonly baseUrl = this.endpoints.parametres_base_endpoint;

    private apiUrl = `${environment.base_url}/api/substances/fetch-and-store`;
    private apiUrl1 = this.baseUrl + '/MLR';  // Assure-toi que l'URL du backend est correcte
    private apiUrl2 = this.baseUrl ; 
    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }

          
    getSubstances(): Observable<SubstanceDTO[]> {
      return this.http.get<SubstanceDTO[]>(this.apiUrl);
    }

    getProductPesticideMRLs(): Observable<ProductPesticideMRL[]> {
      return this.http.get<ProductPesticideMRL[]>(this.apiUrl1).pipe(
        catchError((error) => {
          console.error('Erreur lors de la récupération des données:', error);
          return throwError(() => new Error('Erreur lors de la récupération des MRLs'));
        })
      );
    }

    refreshProductPesticideMRLs(): Observable<ProductPesticideMRL[]> {
      return this.http.post<ProductPesticideMRL[]>(`${this.apiUrl2}/product-pesticide-mrls`, {});
    }
    public fetchParametreList(parId: number): Observable<CommonResponse>{
        if(parId == null){
            parId = -1
        }
        console.log(`${this.endpoints.parametre_base_endpoint}/findAllShortDtosByTypeAnalyseId/${parId}`)
        return this.http.get<CommonResponse>(`${this.endpoints.parametre_base_endpoint}/findAllShortDtosByTypeAnalyseId/${parId}`);
    }

    getParameterByAnalyseId(analyseId: number): Observable<ParameterDTO> {
      return this.http.get<ParameterDTO>(`${this.endpoints.parametres_base_endpoint}/${analyseId}/parameter`);
    }
    getAllParameters(): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(`${this.baseUrl}`);
      }
    
      getAllParametersCreatedByUser(): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(`${this.baseUrl}/get-by-created-user`);
      }
    
      getAllFormules(){
        return this.http.get<any>(`${this.endpoints.parametres_base_endpoint}/formules`);
    }

    getParameterByCasNumber(casNumber: string): Observable<any> {
      return this.http.get<any>(`${this.endpoints.parametres_base_endpoint}/casNumber/${casNumber}`);
    }

      getParameterById(id: number): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(`${this.baseUrl}/${id}`);
      }

      createParameter(parameter: ParameterDTO): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(`${this.baseUrl}`, parameter);
      }
    
      updateParameter(id: number, parameter: ParameterDTO): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(`${this.baseUrl}/${id}`, parameter);
      }
    
      deleteParameter(id: number): Observable<CommonResponse> {
        return this.http.delete<CommonResponse>(`${this.baseUrl}/${id}`);
      }
}
